export default __webpack_public_path__ + "9742de1ccb2c6edaa5245f07b78637cb.webp";